/* Endurrad — scheda prodotto (sections/erd-prodotto.liquid). File aggiunto: sopravvive agli aggiornamenti del tema.
   Galleria e ingrandimento, quantità, varianti, compatibilità con la moto scelta (localStorage «erd_moto_sel»),
   «Ok per la tua moto», barra fissa di acquisto, «Spesso acquistati insieme», pillole di navigazione, fisarmoniche su smartphone. */
(function () {
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function norm(s) { return String(s || '').trim().toLowerCase().replace(/\s+/g, ' '); }
  var euro = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });
  function soldi(c) { return euro.format((c || 0) / 100); }
  var mobile = window.matchMedia('(max-width: 899px)');

  function init() {
    var root = $('[data-erd-pp]');
    if (!root) return;

    /* ---------- Galleria ---------- */
    var imgs = $$('[data-erd-img]', root);
    var big = $('.erd-pp__big', root);
    var strip = $('[data-erd-strip]', root);
    var dots = $$('.erd-pp__dots i', root);
    var nEl = $('[data-erd-n]', root);
    var cur = 0;
    function mostra(i) {
      if (!imgs.length) return;
      cur = (i + imgs.length) % imgs.length;
      imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === cur); });
      $$('[data-erd-th]', root).forEach(function (t) { t.classList.toggle('is-on', +t.getAttribute('data-erd-th') === cur); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === Math.min(cur, dots.length - 1)); });
      if (nEl) nEl.textContent = cur + 1;
      if (strip) strip.scrollTo({ left: strip.clientWidth * cur, behavior: 'smooth' });
    }
    $$('[data-erd-th]', root).forEach(function (t) {
      t.addEventListener('click', function () { mostra(+t.getAttribute('data-erd-th')); });
    });
    /* Scorrimento col dito (o col trackpad): aggiorna miniature, contatore e pallini */
    if (strip) strip.addEventListener('scroll', function () {
      var i = Math.round(strip.scrollLeft / Math.max(1, strip.clientWidth));
      if (i === cur || i < 0 || i >= imgs.length) return;
      cur = i;
      imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === cur); });
      $$('[data-erd-th]', root).forEach(function (t) { t.classList.toggle('is-on', +t.getAttribute('data-erd-th') === cur); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === Math.min(cur, dots.length - 1)); });
      if (nEl) nEl.textContent = cur + 1;
    }, { passive: true });

    /* Frecce e trascinamento col mouse (sul computer) */
    $$('[data-erd-nav]', root).forEach(function (b) {
      b.addEventListener('click', function () { mostra(cur + +b.getAttribute('data-erd-nav')); });
    });
    var trascinato = false;
    if (strip) {
      var giu = null;
      strip.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        giu = { x: e.clientX, sl: strip.scrollLeft }; trascinato = false;
      });
      window.addEventListener('pointermove', function (e) {
        if (!giu) return;
        var dx = e.clientX - giu.x;
        if (!trascinato && Math.abs(dx) > 6) { trascinato = true; strip.classList.add('is-drag'); }
        if (trascinato) { e.preventDefault(); strip.scrollLeft = giu.sl - dx; }
      });
      window.addEventListener('pointerup', function (e) {
        if (!giu) return;
        var dx = e.clientX - giu.x, w = strip.clientWidth, base = Math.round(giu.sl / w);
        giu = null;
        if (!trascinato) return;
        strip.classList.remove('is-drag');
        var dest = Math.abs(dx) > w * 0.12 ? base + (dx < 0 ? 1 : -1) : base;
        dest = Math.max(0, Math.min(imgs.length - 1, dest));
        cur = -1; mostra(dest);
        setTimeout(function () { trascinato = false; }, 50);
      });
    }

    /* Ingrandimento: a tutto schermo, con zoom vero.
       Computer: clic sulla foto = ingrandisce nel punto cliccato, il mouse sposta la vista; secondo clic = torna intera.
       iPhone/iPad: pizzico con due dita o doppio tocco per ingrandire, un dito per spostarsi; a foto intera si scorre di lato. */
    var zoom = null, zst = null, zim = null, zi = 0;
    var S = 1, X = 0, Y = 0, punti = {}, pinch = null, pan = null, swipe = null, ultimoTap = 0, mosso = false;
    function applica(anim) {
      zim.style.transition = anim ? 'transform .22s ease' : 'none';
      zim.style.transform = 'translate(' + X + 'px,' + Y + 'px) scale(' + S + ')';
      zoom.classList.toggle('is-zoom', S > 1.01);
    }
    function limita() {
      var r = zst.getBoundingClientRect(), w = zim.offsetWidth * S, h = zim.offsetHeight * S;
      var mx = Math.max(0, (w - r.width) / 2), my = Math.max(0, (h - r.height) / 2);
      X = Math.max(-mx, Math.min(mx, X)); Y = Math.max(-my, Math.min(my, Y));
    }
    function zoomA(ns, cx, cy, anim) {
      var r = zst.getBoundingClientRect();
      var ox = cx - (r.left + r.width / 2), oy = cy - (r.top + r.height / 2);
      ns = Math.max(1, Math.min(4, ns));
      X = ox - (ox - X) * ns / S; Y = oy - (oy - Y) * ns / S; S = ns;
      if (S <= 1.01) { S = 1; X = 0; Y = 0; }
      limita(); applica(anim);
    }
    function azzera() { S = 1; X = 0; Y = 0; if (zim) applica(false); }
    function apriZoom(i) {
      if (!imgs.length) return;
      if (!zoom) {
        zoom = document.createElement('div');
        zoom.className = 'erd-pp-zoom';
        zoom.setAttribute('role', 'dialog');
        zoom.setAttribute('aria-modal', 'true');
        zoom.setAttribute('aria-label', 'Foto ingrandita');
        zoom.innerHTML = '<div class="erd-pp-zoom__st"><img alt="" draggable="false"></div><button type="button" class="is-x" aria-label="Chiudi">×</button><button type="button" class="is-prev" aria-label="Foto precedente">‹</button><button type="button" class="is-next" aria-label="Foto successiva">›</button><span class="erd-pp-zoom__n"></span><span class="erd-pp-zoom__h"></span>';
        document.body.appendChild(zoom);
        zst = $('.erd-pp-zoom__st', zoom); zim = $('img', zst);
        $('.erd-pp-zoom__h', zoom).textContent = window.matchMedia('(hover: hover) and (pointer: fine)').matches ? 'Clic sulla foto per ingrandire' : 'Pizzica o tocca due volte per ingrandire';
        $('.is-x', zoom).addEventListener('click', chiudiZoom);
        $('.is-prev', zoom).addEventListener('click', function () { vediZoom(zi - 1); });
        $('.is-next', zoom).addEventListener('click', function () { vediZoom(zi + 1); });
        document.addEventListener('keydown', function (e) {
          if (zoom.hidden) return;
          if (e.key === 'Escape') chiudiZoom();
          if (e.key === 'ArrowLeft') vediZoom(zi - 1);
          if (e.key === 'ArrowRight') vediZoom(zi + 1);
        });
        zst.addEventListener('wheel', function (e) {
          e.preventDefault();
          zoomA(S * (e.deltaY < 0 ? 1.15 : 1 / 1.15), e.clientX, e.clientY, false);
        }, { passive: false });
        zst.addEventListener('pointerdown', function (e) {
          zst.setPointerCapture(e.pointerId);
          punti[e.pointerId] = { x: e.clientX, y: e.clientY };
          var ids = Object.keys(punti);
          mosso = false;
          if (ids.length === 2) {
            var a = punti[ids[0]], b = punti[ids[1]];
            pinch = { d: Math.hypot(a.x - b.x, a.y - b.y), s: S }; pan = null; swipe = null;
          } else if (ids.length === 1) {
            pan = { x: e.clientX, y: e.clientY, X: X, Y: Y };
            swipe = S <= 1.01 ? { x: e.clientX, y: e.clientY } : null;
          }
        });
        zst.addEventListener('pointermove', function (e) {
          if (!punti[e.pointerId]) {
            /* Mouse senza tasto premuto: con la foto ingrandita la vista segue il puntatore */
            if (e.pointerType === 'mouse' && S > 1.01) {
              var r = zst.getBoundingClientRect();
              var w = zim.offsetWidth * S, h = zim.offsetHeight * S;
              X = -((e.clientX - r.left) / r.width - 0.5) * Math.max(0, w - r.width);
              Y = -((e.clientY - r.top) / r.height - 0.5) * Math.max(0, h - r.height);
              applica(false);
            }
            return;
          }
          punti[e.pointerId] = { x: e.clientX, y: e.clientY };
          var ids = Object.keys(punti);
          if (pinch && ids.length === 2) {
            var a = punti[ids[0]], b = punti[ids[1]];
            var d = Math.hypot(a.x - b.x, a.y - b.y);
            zoomA(pinch.s * d / pinch.d, (a.x + b.x) / 2, (a.y + b.y) / 2, false);
            mosso = true;
          } else if (pan && S > 1.01 && e.pointerType !== 'mouse') {
            X = pan.X + e.clientX - pan.x; Y = pan.Y + e.clientY - pan.y;
            if (Math.abs(e.clientX - pan.x) + Math.abs(e.clientY - pan.y) > 6) mosso = true;
            limita(); applica(false);
          } else if (swipe) {
            var dx = e.clientX - swipe.x;
            if (Math.abs(dx) > 6) mosso = true;
            zim.style.transition = 'none';
            zim.style.transform = 'translateX(' + dx + 'px)';
          }
        });
        function fine(e) {
          if (!punti[e.pointerId]) return;
          delete punti[e.pointerId];
          if (pinch) { if (Object.keys(punti).length < 2) pinch = null; return; }
          if (swipe) {
            var dx = e.clientX - swipe.x; swipe = null;
            if (Math.abs(dx) > 60 && imgs.length > 1) { vediZoom(zi + (dx < 0 ? 1 : -1)); return; }
            applica(true);
          }
          pan = null;
          if (mosso) return;
          /* Tocco o clic senza movimento */
          if (e.pointerType === 'mouse') { zoomA(S > 1.01 ? 1 : 2.5, e.clientX, e.clientY, true); return; }
          var ora = Date.now();
          if (ora - ultimoTap < 300) { ultimoTap = 0; zoomA(S > 1.01 ? 1 : 2.5, e.clientX, e.clientY, true); }
          else ultimoTap = ora;
        }
        zst.addEventListener('pointerup', fine);
        zst.addEventListener('pointercancel', function (e) { delete punti[e.pointerId]; pinch = null; pan = null; swipe = null; applica(true); });
        zoom.addEventListener('click', function (e) { if (e.target === zoom) chiudiZoom(); });
      }
      zoom.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      vediZoom(i);
      $('.is-x', zoom).focus();
    }
    function vediZoom(i) {
      zi = (i + imgs.length) % imgs.length;
      var im = imgs[zi];
      azzera();
      zim.src = (im.currentSrc || im.src).replace(/width=\d+/, 'width=2400');
      zim.alt = im.alt;
      $('.erd-pp-zoom__n', zoom).textContent = (zi + 1) + ' / ' + imgs.length;
      zoom.classList.toggle('is-una', imgs.length < 2);
    }
    function chiudiZoom() { zoom.hidden = true; punti = {}; pinch = pan = swipe = null; azzera(); document.documentElement.style.overflow = ''; }
    $$('[data-erd-zoom-open]', root).forEach(function (b) {
      b.addEventListener('click', function () { apriZoom(b.getAttribute('data-erd-zoom-open') ? +b.getAttribute('data-erd-zoom-open') : cur); });
    });
    /* Clic sul computer o tocco su iPhone apre la foto ingrandita (non dopo un trascinamento) */
    imgs.forEach(function (im, k) { im.setAttribute('draggable', 'false'); im.addEventListener('click', function () { if (!trascinato) apriZoom(k); }); });
    /* ---------- «Avvisami quando disponibile» (sostituisce Notify Me!) ----------
       Invio all'App Proxy /apps/endurrad/stock-request: stessa richiesta dell'app Endurrad
       (email a support@endurrad.com, metaoggetto letto da Riordino Endurrad, email al cliente al ritorno). */
    var dlg = $('[data-erd-avv-dlg]', root);
    if (dlg) {
      var fAvv = $('[data-erd-avv-form]', dlg), fatto = $('[data-erd-avv-fatto]', dlg), errAvv = $('[data-erd-avv-err]', dlg), goAvv = $('[data-erd-avv-go]', dlg);
      var nomeBase = ($('[data-erd-avv-nome]', dlg) || {}).textContent || '';
      var ua = navigator.userAgent || '';
      if (/iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) { var a1 = $('[data-store="android"]', dlg); if (a1) a1.hidden = true; }
      if (/Android/i.test(ua)) { var a2 = $('[data-store="ios"]', dlg); if (a2) a2.hidden = true; }
      function varianteAttuale() { var x = $('[data-erd-vid]', root); return x ? x.value : ''; }
      function nomeAttuale() {
        var s = $$('[data-erd-opts] fieldset', root).map(function (f) { var c = $('input:checked', f); return c ? c.value : null; }).filter(Boolean);
        var base = nomeBase.replace(/\s*\([^)]*\)\s*$/, '');
        return s.length && nomeBase !== base ? base + ' (' + s.join(' / ') + ')' : nomeBase;
      }
      function apriAvv() {
        fAvv.hidden = false; fatto.hidden = true; errAvv.hidden = true;
        var n = $('[data-erd-avv-nome]', dlg); if (n) n.textContent = nomeAttuale();
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        var primo = $$('input', fAvv).filter(function (i) { return !i.value && i.name !== 'website' && i.type !== 'checkbox'; })[0];
        if (primo && !window.matchMedia('(pointer: coarse)').matches) primo.focus();
      }
      function chiudiAvv() { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
      $$('[data-erd-avv]', root).forEach(function (b) { b.addEventListener('click', apriAvv); });
      $$('[data-erd-avv-x]', dlg).forEach(function (b) { b.addEventListener('click', chiudiAvv); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) chiudiAvv(); });
      function errore(msg) { errAvv.textContent = msg; errAvv.hidden = false; }
      fAvv.addEventListener('submit', function (e) {
        e.preventDefault();
        errAvv.hidden = true;
        var el = fAvv.elements, msg = '';
        ['firstName', 'lastName', 'email', 'phone'].forEach(function (k) { el[k].classList.remove('is-err'); });
        var val = function (k) { return (el[k].value || '').trim(); };
        if (!val('firstName')) { el.firstName.classList.add('is-err'); msg = msg || 'Scrivi il tuo nome.'; }
        if (!val('lastName')) { el.lastName.classList.add('is-err'); msg = msg || 'Scrivi il tuo cognome.'; }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val('email'))) { el.email.classList.add('is-err'); msg = msg || "Inserisci un'email valida."; }
        if (val('phone') && (!/^\+?[0-9 ]+$/.test(val('phone')) || val('phone').replace(/\D/g, '').length < 6)) { el.phone.classList.add('is-err'); msg = msg || 'Telefono: usa solo cifre, spazi e il segno +.'; }
        if (!msg && !el.consent.checked) msg = "Per continuare accetta l'uso dei dati.";
        if (msg) { errore(msg); return; }
        goAvv.disabled = true;
        fetch('/apps/endurrad/stock-request', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            productId: +root.getAttribute('data-product-id'), variantId: +varianteAttuale(),
            firstName: val('firstName'), lastName: val('lastName'), email: val('email'), phone: val('phone'),
            consent: true, website: el.website.value || '',
            lang: ((window.Shopify && Shopify.locale) || document.documentElement.lang || 'it').slice(0, 2)
          })
        }).then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok || !j.ok) throw new Error(j.error || ('Invio non riuscito (codice ' + r.status + '). Riprova tra poco.'));
          });
        }).then(function () {
          $('[data-erd-avv-mail]', dlg).textContent = val('email');
          fAvv.hidden = true; fatto.hidden = false;
        }).catch(function (err) {
          errore(err && err.message && !/fetch|network|load failed/i.test(err.message) ? err.message : 'Connessione non riuscita. Controlla la rete e riprova.');
        }).then(function () { goAvv.disabled = false; });
      });
    }

    var vbtn = $('[data-erd-video]', root);
    if (vbtn) vbtn.addEventListener('click', function () {
      var r = $('#erd-montaggio');
      if (r) r.scrollIntoView({ behavior: 'smooth' });
    });

    /* ---------- Quantità ---------- */
    var qIn = $('[data-erd-qty-in]', root);
    $$('[data-erd-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        qIn.value = Math.max(1, (parseInt(qIn.value, 10) || 1) + parseInt(b.getAttribute('data-erd-qty'), 10));
      });
    });

    /* ---------- Varianti ---------- */
    var vJson = $('[data-erd-varianti]', root);
    if (vJson) {
      var varianti = [];
      try { varianti = JSON.parse(vJson.textContent); } catch (e) {}
      var vids = $$('[data-erd-vid]', root);
      function scelte() {
        return $$('[data-erd-opts] fieldset', root).map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
      }
      function aggiornaVariante() {
        var s = scelte();
        var v = varianti.filter(function (x) { return x.options.every(function (o, i) { return o === s[i]; }); })[0];
        $$('[data-erd-add]').forEach(function (b) {
          b.disabled = !v || !v.available;
          var t = $('.btn-text > span', b);
          if (t) t.textContent = !v ? 'Non disponibile' : (v.available ? 'Aggiungi al carrello' : 'Esaurito');
        });
        root.classList.toggle('is-esaurito', !!v && !v.available);
        var atc = $('.erd-pp__atc', root);
        if (atc) atc.classList.toggle('is-esaurito', !!v && !v.available);
        if (!v) return;
        vids.forEach(function (x) { x.value = v.id; });
        $$('[data-erd-prezzo]').forEach(function (e) { e.textContent = soldi(v.price); });
        var pieno = $('[data-erd-pieno]', root), risp = $('[data-erd-risp]', root);
        var sconto = v.compare > v.price;
        pieno.hidden = !sconto; risp.hidden = !sconto;
        if (sconto) { pieno.textContent = soldi(v.compare); risp.textContent = 'Risparmi ' + soldi(v.compare - v.price).replace(',00', ''); }
        var rate = $('[data-erd-rate]', root);
        if (rate) { rate.hidden = v.price < 3000 || v.price > 200000; $('[data-erd-rata]', rate).textContent = soldi(Math.floor(v.price / 3)); }
        var disp = $('[data-erd-disp]', root);
        if (disp) {
          var testo, cls = 'erd-pp__s1';
          if (!v.available) testo = 'Esaurito';
          else if (v.qty === 1) testo = 'Ultimo pezzo disponibile';
          else if (v.qty !== null && v.qty > 0 && v.qty <= 3) testo = 'Ultimi ' + v.qty + ' pezzi disponibili';
          else { testo = 'Disponibile, pronto per la spedizione'; cls = 'erd-pp__s0'; }
          disp.className = cls;
          disp.innerHTML = '<i aria-hidden="true"></i>' + testo;
        }
        if (v.img > 0) mostra(v.img - 1);
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u.toString());
        } catch (e) {}
      }
      $$('[data-erd-opt]', root).forEach(function (r) { r.addEventListener('change', aggiornaVariante); });
    }

    /* ---------- Compatibilità con la moto scelta ---------- */
    var comp = $('[data-erd-comp]', root);
    if (comp) {
      var m = null;
      try { m = JSON.parse(window.localStorage.getItem('erd_moto_sel') || 'null'); } catch (e) {}
      var nome = m && m.base ? ((m.marca ? m.marca + ' ' : '') + m.base) : '';
      var t = $('[data-erd-comp-t]', comp), p = $('[data-erd-comp-p]', comp), ic = $('[data-erd-comp-i]', comp);
      var modelli = (comp.getAttribute('data-modelli') || '').split('|').filter(Boolean);
      var univ = comp.getAttribute('data-universale') === 'true';
      var barre = comp.getAttribute('data-barre') === 'true';
      t.textContent = nome ? 'Va bene per la tua ' + nome + '?' : 'Va bene per la tua moto?';
      if (!barre) {
        var qm = $('[data-erd-q-moto]', comp);
        if (nome && modelli.length && modelli.some(function (x) { return norm(x) === norm(m.base); })) {
          comp.classList.add('is-ok');
          ic.textContent = '✓';
          t.textContent = 'Ok per la tua ' + nome;
          p.textContent = 'Compatibilità indicata dal produttore per il tuo modello.';
        } else if (nome && univ) {
          comp.classList.add('is-ok');
          ic.textContent = '✓';
          t.textContent = 'Ok per la tua ' + nome;
        } else if (!nome && qm) {
          qm.hidden = false;
        } else if (nome && modelli.length && qm) {
          t.textContent = 'Per la tua ' + nome + ' non è indicato';
          qm.hidden = false;
          var sb = $('[data-erd-scegli]', qm);
          if (sb) sb.textContent = 'Cambia moto';
        }
      }
      $$('[data-erd-q]', comp).forEach(function (b) {
        if (b.tagName === 'BUTTON') b.addEventListener('click', function () {
          $$('[data-erd-q]', comp).forEach(function (x) { x.classList.toggle('is-on', x === b); if (x.tagName === 'BUTTON') x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        });
      });
      var sc = $('[data-erd-scegli]', comp);
      if (sc) sc.addEventListener('click', function () {
        var b = $('[data-erd-sel-btn]') || $('[data-erd-garage-btn]');
        if (!b) return;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(function () { b.click(); }, 250);
      });
    }

    /* Cuore se il prodotto è tra i preferiti (dati di erd-garage-preferiti) */
    try {
      var pref = $('#erd-preferiti-dati');
      var h = (window.location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
      if (pref && h && JSON.parse(pref.textContent).indexOf(decodeURIComponent(h)) > -1) $('[data-erd-fav]', root).hidden = false;
    } catch (e) {}

    /* ---------- Pulsanti fissi e barra di acquisto ---------- */
    var cta = $('[data-erd-cta]', root);
    var bar = $('[data-erd-bar]', root);
    var buy = $('[data-erd-buy]', root);
    if (cta && bar && 'IntersectionObserver' in window) {
      var ctaVis = true;
      function aggBar() {
        var on = !ctaVis;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('button', bar).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      }
      new IntersectionObserver(function (e) { ctaVis = e[0].isIntersecting; aggBar(); }, { threshold: 0.2, rootMargin: (mobile.matches ? '-60px' : '-84px') + ' 0px 0px 0px' }).observe(cta);
      /* ombra quando i pulsanti sono fissati in basso nella colonna */
      window.addEventListener('scroll', function () {
        if (mobile.matches) return;
        var r = cta.getBoundingClientRect();
        var br = buy.getBoundingClientRect();
        cta.classList.toggle('is-stuck', (Math.abs(r.bottom - window.innerHeight) < 2 && br.bottom > window.innerHeight + 2) || (r.top < 120 && br.top < r.top - 2 && br.bottom > r.bottom + 2));
      }, { passive: true });
    }

    /* ---------- Spesso acquistati insieme ---------- */
    var ins = $('[data-erd-insieme]', root);
    if (ins) {
      var tot = $('[data-erd-ins-tot]', ins), nn = $('[data-erd-ins-n]', ins), add = $('[data-erd-ins-add]', ins), err = $('[data-erd-ins-err]', ins);
      function scelti() { return $$('input[type="checkbox"]', ins).filter(function (c) { return c.checked; }); }
      function ricalcola() {
        var s = scelti();
        tot.textContent = soldi(s.reduce(function (a, c) { return a + (+c.getAttribute('data-prezzo') || 0); }, 0));
        nn.textContent = s.length;
        add.disabled = !s.length;
        add.textContent = mobile.matches ? 'Aggiungi ' + (s.length > 1 ? 'tutti · ' : '') + tot.textContent : (s.length > 1 ? 'Aggiungi tutti e ' + s.length : 'Aggiungi al carrello');
        $$('.erd-pp__bi', ins).forEach(function (l) { l.classList.toggle('is-off', !$('input', l).checked); });
      }
      ins.addEventListener('change', ricalcola);
      ricalcola();
      add.addEventListener('click', function () {
        var items = scelti().map(function (c) { return { id: +c.getAttribute('data-id'), quantity: 1 }; });
        if (!items.length) return;
        add.setAttribute('aria-busy', 'true'); add.disabled = true; err.hidden = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
          .then(function (cart) {
            try { if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'erd-insieme', cart: cart }); } catch (e) {}
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
            var d = document.querySelector('cart-drawer');
            if (d && typeof d.show === 'function') setTimeout(function () { d.show(add); }, 300);
            else window.location.href = '/cart';
          })
          .catch(function (e) { err.textContent = (e && (e.description || e.message)) || 'Non siamo riusciti ad aggiungere i prodotti. Riprova.'; err.hidden = false; })
          .finally(function () { add.removeAttribute('aria-busy'); add.disabled = false; });
      });
    }

    /* ---------- Barra delle sezioni ---------- */
    var tabs = $$('[data-erd-tabs] a', root);
    if (tabs.length && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          tabs.forEach(function (a) { a.classList.toggle('is-on', a.getAttribute('href') === '#' + e.target.id); });
        });
      }, { rootMargin: '-30% 0px -60% 0px' });
      tabs.forEach(function (a) { var s = $(a.getAttribute('href')); if (s) obs.observe(s); });
    }
    var snav = $('[data-erd-snav]', root);
    if (snav) {
      var aggSnav = function () {
        var t = parseFloat(getComputedStyle(snav).top) || 0;
        var stuck = snav.getBoundingClientRect().top <= t + 1 && window.scrollY > 200;
        snav.classList.toggle('is-stuck', stuck);
        if (window.scrollY < 300 && tabs[0]) tabs.forEach(function (a, k) { a.classList.toggle('is-on', k === 0); });
        $$('button', snav).forEach(function (b) { b.tabIndex = stuck ? 0 : -1; });
      };
      window.addEventListener('scroll', aggSnav, { passive: true });
      aggSnav();
    }

    /* ---------- Box con immagine: «Continua a leggere» ---------- */
    $$('[data-erd-st-rd]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var art = b.closest('[data-erd-st]');
        var aperto = art.classList.toggle('is-open');
        b.setAttribute('aria-expanded', aperto ? 'true' : 'false');
        b.firstChild.nodeValue = aperto ? 'Chiudi ' : 'Continua a leggere ';
      });
    });

    /* ---------- Recensioni ---------- */
    function sezioneJudge() { var w = document.querySelector('.jdgm-widget, .jdgm-rev-widg, .jdgm-review-widget'); return w ? (w.closest('.shopify-section') || w) : null; }
    function apriTutte(scrivi) {
      document.body.classList.add('erd-rec-aperte');
      var s = sezioneJudge();
      if (!s) return;
      s.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (scrivi) {
        var l = s.querySelector('.jdgm-write-rev-link, [class*="write-rev"]');
        if (l) setTimeout(function () { l.click(); }, 400);
      }
    }
    var tutte = $('[data-erd-tutte-rec]', root);
    if (tutte) tutte.addEventListener('click', function () { apriTutte(false); });
    var scrivi = $('[data-erd-scrivi]', root);
    if (scrivi) scrivi.addEventListener('click', function () { apriTutte(true); });
    if (/#judgeme|jdgm/.test(location.hash)) document.body.classList.add('erd-rec-aperte');

    $$('[data-erd-rf]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-erd-rf'), n = 0;
        $$('[data-erd-rf]', root).forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        $$('[data-erd-rv]', root).forEach(function (r) {
          var ok = f === 'tutte' || (f === 'foto' ? +r.getAttribute('data-foto') > 0 : r.getAttribute('data-stelle') === f);
          r.hidden = !ok; if (ok) n++;
        });
        var vuoto = $('[data-erd-rv-vuoto]', root);
        if (vuoto) vuoto.hidden = n > 0;
      });
    });

    var fotoBox = null;
    function apriFoto(src, chi, testo, origine) {
      if (!fotoBox) {
        fotoBox = document.createElement('div');
        fotoBox.className = 'erd-pp-foto';
        fotoBox.setAttribute('role', 'dialog');
        fotoBox.setAttribute('aria-modal', 'true');
        fotoBox.setAttribute('aria-label', 'Foto del cliente');
        fotoBox.innerHTML = '<button type="button" aria-label="Chiudi">×</button><figure><img alt=""><figcaption><b></b><span></span></figcaption></figure>';
        document.body.appendChild(fotoBox);
        var chiudi = function () { fotoBox.hidden = true; document.documentElement.style.overflow = ''; if (fotoBox._o) fotoBox._o.focus(); };
        fotoBox.addEventListener('click', function (e) { if (e.target === fotoBox || e.target.tagName === 'BUTTON') chiudi(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !fotoBox.hidden) chiudi(); });
      }
      fotoBox._o = origine;
      $('img', fotoBox).src = src;
      $('img', fotoBox).alt = 'Foto di ' + chi;
      $('figcaption b', fotoBox).textContent = chi;
      $('figcaption span', fotoBox).textContent = testo;
      fotoBox.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      $('button', fotoBox).focus();
    }
    $$('[data-erd-pf]', root).forEach(function (b) {
      b.addEventListener('click', function () { apriFoto(b.getAttribute('data-erd-pf'), b.getAttribute('data-chi') || '', b.getAttribute('data-testo') || '', b); });
    });
    var pfAll = $('[data-erd-pf-all]', root);
    if (pfAll) pfAll.addEventListener('click', function () { $$('.erd-pp__pf.is-extra', root).forEach(function (x) { x.hidden = false; }); pfAll.remove(); });

    /* ---------- Domande frequenti: tutte ---------- */
    var fa = $('[data-erd-faq-all]', root);
    if (fa) fa.addEventListener('click', function () { $$('.erd-pp__fq.is-extra', root).forEach(function (d) { d.hidden = false; }); fa.remove(); });

    /* ---------- Prodotti consigliati (Shopify) ---------- */
    var racc = $('[data-erd-racc]', root);
    if (racc && window.fetch) {
      var carica = function () {
        fetch(racc.getAttribute('data-url'))
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var d = document.createElement('div'); d.innerHTML = html;
            var g = d.querySelector('[data-erd-racc-ok]');
            if (!g) return;
            $('[data-erd-racc-g]', racc).appendChild(g);
            racc.hidden = false;
          })
          .catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var ro = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { ro.disconnect(); carica(); } }, { rootMargin: '600px 0px' });
        ro.observe(racc.previousElementSibling || racc);
      } else carica();
    }

    /* ---------- Fisarmoniche: aperte su computer, chiuse su smartphone ---------- */
    function fisarmoniche() {
      $$('[data-erd-acc]', root).forEach(function (d) { if (mobile.matches) d.removeAttribute('open'); else d.setAttribute('open', ''); });
    }
    fisarmoniche();
    $$('[data-erd-acc] > summary', root).forEach(function (s) {
      s.addEventListener('click', function (e) { if (!mobile.matches) e.preventDefault(); });
    });
    tabs.forEach(function (a) { a.addEventListener('click', function () { var s = $(a.getAttribute('href')); if (s && s.tagName === 'DETAILS') s.setAttribute('open', ''); }); });
    if (mobile.addEventListener) mobile.addEventListener('change', fisarmoniche);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* «Ordina entro le 12:00»: solo dove c'è la consegna in 2-3 giorni lavorativi (LOBOO, JADO, CHIGEE, Endurrad).
   Ordini dal lunedì al venerdì entro le 12:00 (ora italiana) partono in giornata;
   consegna tra 2 e 3 giorni lavorativi dopo la partenza (15/10/2026). Esclusi sabato, domenica e festivi nazionali. */
(function () {
  var el = document.querySelector('[data-erd-entro]');
  if (!el || !window.Intl) return;
  var ORA_LIMITE = 12;
  var GIORNI = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
  var MESI = ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'];
  function pasquetta(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
        g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
        mese = Math.floor((h + l - 7 * m + 114) / 31), giorno = ((h + l - 7 * m + 114) % 31) + 1;
    var p = new Date(Date.UTC(y, mese - 1, giorno + 1));
    return (p.getUTCMonth() + 1) + '-' + p.getUTCDate();
  }
  function lavorativo(d) {
    var w = d.getUTCDay(); if (w === 0 || w === 6) return false;
    var k = (d.getUTCMonth() + 1) + '-' + d.getUTCDate();
    return ['1-1', '1-6', '4-25', '5-1', '6-2', '8-15', '11-1', '12-8', '12-25', '12-26', pasquetta(d.getUTCFullYear())].indexOf(k) === -1;
  }
  function dopo(d) { var n = new Date(d.getTime()); n.setUTCDate(n.getUTCDate() + 1); return n; }
  function aggiorna() {
    var parti = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (p) { parti[p.type] = +p.value; });
    var oggi = new Date(Date.UTC(parti.year, parti.month - 1, parti.day));
    var minuti = parti.hour * 60 + parti.minute;
    var partenza = oggi, inGiornata = lavorativo(oggi) && minuti < ORA_LIMITE * 60;
    if (!inGiornata) { partenza = dopo(oggi); while (!lavorativo(partenza)) partenza = dopo(partenza); }
    var arrivo = partenza, n = 0;
    while (n < 2) { arrivo = dopo(arrivo); if (lavorativo(arrivo)) n++; }
    var arrivo3 = dopo(arrivo);
    while (!lavorativo(arrivo3)) arrivo3 = dopo(arrivo3);
    var g1 = GIORNI[arrivo.getUTCDay()] + ' ' + arrivo.getUTCDate();
    var g2 = GIORNI[arrivo3.getUTCDay()] + ' ' + arrivo3.getUTCDate() + ' ' + MESI[arrivo3.getUTCMonth()];
    if (arrivo.getUTCMonth() !== arrivo3.getUTCMonth()) g1 += ' ' + MESI[arrivo.getUTCMonth()];
    var quando = 'tra ' + g1 + ' e ' + g2;
    var testo;
    if (inGiornata) {
      var resto = ORA_LIMITE * 60 - minuti, h = Math.floor(resto / 60), m = resto % 60;
      testo = '· ordina entro ' + (h ? h + ' h ' : '') + m + ' min, arriva ' + quando;
    } else {
      testo = '· ordina ora, arriva ' + quando;
    }
    el.textContent = testo;
  }
  aggiorna();
  setInterval(aggiorna, 60000);
})();


/* Barra delle sezioni fissa sotto l'intestazione del sito (che può comparire e sparire durante lo scorrimento) */
(function () {
  var snav = document.querySelector('.erd-pp__snav');
  if (!snav) return;
  var root = document.documentElement, ultimo = -1, inAttesa = false;
  function calcola() {
    inAttesa = false;
    var basso = 0;
    document.querySelectorAll('.shopify-section-group-header-group, sticky-header, .header-section').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.bottom > basso && r.top < 200) basso = r.bottom;
    });
    basso = Math.max(0, Math.round(basso));
    if (basso !== ultimo) { ultimo = basso; root.style.setProperty('--erd-snav-top', basso + 'px'); }
  }
  function pianifica() { if (!inAttesa) { inAttesa = true; requestAnimationFrame(calcola); } }
  window.addEventListener('scroll', pianifica, { passive: true });
  window.addEventListener('resize', pianifica);
  calcola();
  setTimeout(calcola, 800);
})();
